<template>
    <div class="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <img class="mx-auto h-10 w-auto" src="/images/logo.webp" alt="Beckmann Systemlogistik" />
            <h2 class="mt-6 text-center text-2xl font-semibold tracking-tight text-gray-900">Anmelden</h2>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-6 shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl sm:px-10">
                <div v-if="loginFailed"
                     class="mb-6 rounded-md bg-red-50 p-3 text-sm text-red-700 flex items-center gap-2">
                    <ExclamationTriangleIcon class="h-5 w-5 flex-shrink-0 text-red-400" />
                    Ungültiger Benutzername oder ungültiges Passwort.
                </div>

                <form @submit.prevent="submitForm" class="space-y-5">
                    <div>
                        <label for="username" class="block text-sm font-medium text-gray-700">Benutzername oder E-Mail</label>
                        <div class="mt-1.5">
                            <input v-model="form.username" id="username" name="username" type="text"
                                   autocomplete="username" required
                                   placeholder="Benutzername"
                                   class="block w-full rounded-md border-gray-300 px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-secondary focus:ring-secondary sm:text-sm"
                                   :class="loginFailed ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''" />
                        </div>
                    </div>

                    <div>
                        <div class="flex items-center justify-between">
                            <label for="password" class="block text-sm font-medium text-gray-700">Passwort</label>
                            <router-link to="/forgot-password" class="text-xs text-gray-400 hover:text-gray-600">
                                Passwort vergessen?
                            </router-link>
                        </div>
                        <div class="mt-1.5">
                            <input v-model="form.password" id="password" name="password" type="password"
                                   autocomplete="current-password" required
                                   class="block w-full rounded-md border-gray-300 px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-secondary focus:ring-secondary sm:text-sm"
                                   :class="loginFailed ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''" />
                        </div>
                    </div>

                    <button type="submit" :disabled="loading"
                            class="flex w-full justify-center rounded-md bg-primary px-4 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                        <span v-if="loading">Bitte warten...</span>
                        <span v-else>Anmelden</span>
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid';

export default {
    components: {
        ExclamationTriangleIcon,
    },

    data() {
        return {
            loading: false,
            loginFailed: false,
            form: {
                username: '',
                password: '',
            },
        };
    },

    methods: {
        submitForm() {
            this.loading = true;
            this.loginFailed = false;

            axios.post('/api/login', this.form)
                .then((response) => {
                    if (!response.data.success) {
                        this.loginFailed = true;
                        this.loading = false;
                        return;
                    }

                    let token = response.data.token;
                    let level = response.data.level;

                    Cookies.set('token', token, { expires: 1, path: '' });
                    Cookies.set('level', level, { expires: 1, path: '' });

                    location.href = '/';
                })
                .catch(error => {
                    this.loading = false;
                    this.loginFailed = true;
                });
        }
    }
}
</script>
